import lowerFirst from 'lodash/lowerFirst';
import { MessageMedium } from 'constants/messageMediums';
import { WORKFLOW_ACTIONS } from 'modules/workflows/constants';

export const MAX_SELECTED = 4;

export const DROPDOWNS_LIST = [
  { medium: MessageMedium.Email, actionName: lowerFirst(WORKFLOW_ACTIONS.SEND_EMAIL) },
  { medium: MessageMedium.SMS, actionName: lowerFirst(WORKFLOW_ACTIONS.SEND_SMS) },
  { medium: MessageMedium.InApp, actionName: lowerFirst(WORKFLOW_ACTIONS.SEND_IN_APP) },
  { medium: MessageMedium.Push, actionName: lowerFirst(WORKFLOW_ACTIONS.SEND_PUSH) },
  { medium: MessageMedium.WebPush, actionName: lowerFirst(WORKFLOW_ACTIONS.SEND_WEB_PUSH) },
];
